export const cacheKey = "/app_settings/territories_data/:id" as const;
